'use strict';

import errorNotice from '../error';
import summaryChart from './summary';
// import newDayChangeChart from './new-day-change'; // No testing, remove this
// import testsChart from './tests';
//import medicalStats from '../stats/medical-stats'; //TODO add this to backend
import { roundTo } from '../helpers';

const mainCharts = (function() {

    function init(data) {
        if (typeof data.confirmed !== 'undefined') {
            // Init region charts
            //newDayChangeChart.init(data.confirmed);

            // Summary chart
            summaryChart.init(data);
        } else {
            const error = 'Ongelma THL rajapinnassa, dataa sairaanhoitopiireistä ei saatavilla.';
            errorNotice.showDataError(error, '.shp-data-area');
        }

        if (typeof data.vaccines !== 'undefined' && data.vaccines.doses) {
            let vacMarkup = '';
            for (let dose of data.vaccines.doses) {
                const lastWeek = dose.weeks[dose.weeks.length - 1];
                const allAges = lastWeek.ages.filter((item) => item.age === 'all_ages');
                if (allAges.length) {
                    const percent = roundTo(allAges[0].percentage, 1);
                    vacMarkup = '<div class="extra-info">'+dose.dose+'. annos: '+percent + ' %</div>' + vacMarkup;
                }
            }

            const vacPerElem = document.getElementById('js-vaccinated-summary');
            if (vacPerElem) {
                vacPerElem.innerHTML = vacMarkup;
            }
        }

        // Init test charts
        //testsChart.init(data);

        // Init medical charts
        //medicalStats.init(data);
    }

    function reload(data, page) {
        let reloadRate = false;
        const reloadCharts = [];

        // Wave changed
        if (page.classList.contains('reload-wave')) {
            if (reloadCharts.indexOf('summary') === -1) {
                reloadCharts.push('summary');
            }
            page.classList.remove('reload-wave');
        }

        if (page.classList.contains('reload-date')) {
            if (reloadCharts.indexOf('tests') === -1) {
                reloadCharts.push('tests');
            }
            if (reloadCharts.indexOf('new-day-change') === -1) {
                reloadCharts.push('new-day-change');
            }

            // If rate mode selected in municipality chart, update
            const summaryChartModeInput = document.querySelector('input[name="wave"]:checked');
            if (summaryChartModeInput.value === '0' && reloadCharts.indexOf('summary') === -1) {
                reloadCharts.push('summary');
            }

            page.classList.remove('reload-date');
        }

        if (page.classList.contains('reload-rate')) {
            reloadRate = true;
            if (reloadCharts.indexOf('summary') === -1) {
                reloadCharts.push('summary');
            }
            page.classList.remove('reload-rate');
        }

        // Reload charts
        for (let chartType of reloadCharts) {
            if (chartType === 'summary') {
                summaryChart.reload(data, reloadRate);
            }
            if (chartType === 'tests') {
                //testsChart.reload(data);
            }
            if (chartType === 'new-day-change') {
                //newDayChangeChart.reload(data.confirmed);
            }
        }

        page.classList.remove('reload');
    }

    return {
        init,
        reload
    }
})();

export default mainCharts;
